/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */

/**
 * Publico-alvo de um anuncio. **Nao ha segmento por situacao financeira**:
 * seria usar o ledger para escolher destinatario de aviso, o que
 * transforma inadimplencia em rotulo de comunicacao, e nenhum documento
 * pede isso.
 */
export type AnnouncementSegment = typeof AnnouncementSegment[keyof typeof AnnouncementSegment];


export const AnnouncementSegment = {
  all: 'all',
  students: 'students',
  teachers: 'teachers',
  active_students: 'active_students',
} as const;
